import apiClient from '../client';

// Training: the first part of a new driver's time, before normal pay.
// It starts at hire (or here), the trainer is asked every day whether it
// goes on and how it is going, and it ends when they say it is finished.
// Every day inside it is a training day on payroll.
//
// NOTE: the shared apiClient's response interceptor returns response.data.

export type TrainingStatus = 'active' | 'finished' | 'cancelled';

export interface TrainingReport {
  date: string;
  /** morning: with the trainer?  evening: does it continue?  schedule: days and capacity set. */
  kind?: 'morning' | 'evening' | 'schedule';
  withTrainer?: boolean | null;
  continuing: boolean | null;
  note: string;
  byAccountId: string | null;
  byName: string | null;
}

export interface TrainingPeriod {
  id: string;
  accountId: string;
  name: string | null;
  trainerId: string | null;
  trainerName: string | null;
  status: TrainingStatus;
  startedOn: string;
  /** The last training day, once finished. */
  endedOn: string | null;
  endedByName: string | null;
  source: 'hire' | 'manual';
  note: string;
  /** Days from start to end (or to today). */
  days: number;
  reports: TrainingReport[];
}

class TrainingService {
  private static readonly BASE = '/api/training';

  static async list(accountId?: string): Promise<TrainingPeriod[]> {
    const body: { training: TrainingPeriod[] } = await apiClient.get(this.BASE, { params: accountId ? { accountId } : {} }) as any;
    return body.training;
  }

  static async start(input: { accountId: string; startedOn: string; trainerId?: string | null; note?: string }): Promise<TrainingPeriod> {
    return apiClient.post(this.BASE, input) as any;
  }

  static async update(id: string, input: { startedOn?: string; endedOn?: string | null; trainerId?: string | null; status?: TrainingStatus }): Promise<TrainingPeriod> {
    return apiClient.patch(`${this.BASE}/${id}`, input) as any;
  }

  static async report(id: string, input: { continuing: boolean; note?: string }): Promise<TrainingPeriod> {
    return apiClient.post(`${this.BASE}/${id}/reports`, input) as any;
  }
}

export default TrainingService;
